import actionTypes from './actionTypes';
import UserSources from '../../sources/user';
import { addNotification } from './notification';

export const fetchUserNotifications = ({ authenticationToken }) => async (dispatch) => {

    dispatch({
        type: actionTypes.USER_NOTIFICATIONS_LOADING,
    });

    const userNotifications = await UserSources.getCurrentUserNotifications({ authenticationToken });

    dispatch({
        type: actionTypes.USER_NOTIFICATIONS_SET,
        payload: userNotifications,
    });
};

export const readSingleUserNotification = ({ id, authenticationToken }) => (dispatch) => {

    UserSources.getSingleUserNotification({ id, authenticationToken })
        .then(readUserNotification => dispatch({
            type: actionTypes.USER_NOTIFICATIONS_UPDATE_SINGLE,
            payload: readUserNotification,
        }))
        .catch(error => dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        })));
};

export const readAllUserNotifications = ({ authenticationToken }) => (dispatch) => {

    UserSources.readAllUserNotifications({ authenticationToken })
        .then(() => dispatch({
            type: actionTypes.USER_NOTIFICATIONS_UPDATE_ALL,
        }))
        .catch(error => dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        })));
};
